/**
 * RequireAnthropicKey — the hard gate (V1-10).
 *
 * Wraps protected routes that need Claude. Behavior:
 *   - While the AnthropicKeyContext is still loading status → spinner.
 *   - If the user has a key on file → render children (real app).
 *   - If they don't → render <KeySetup /> in place. No URL change, no flash
 *     redirect. When they save successfully, the context refreshes and this
 *     component re-renders with children.
 *
 * Compose AFTER ProtectedRoute (which guarantees auth). So the chain is:
 *     ProtectedRoute → RequireAnthropicKey → page
 */
import { Box, CircularProgress } from '@mui/material';
import { useAnthropicKey } from '../context/AnthropicKeyContext';
import KeySetup from '../pages/KeySetup';

export default function RequireAnthropicKey({ children }) {
  const { has_key, loading } = useAnthropicKey();

  if (loading) {
    return (
      <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        sx={{ minHeight: 'calc(100vh - 64px)' }}
      >
        <CircularProgress />
      </Box>
    );
  }

  if (!has_key) {
    return <KeySetup />;
  }

  return children;
}
